// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"aL-z","carouselContainer":"bL-z"};